// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"150":"a8dab2d3","156":"ce1f0878","354":"9b7b5c8f","825":"daf38fe4"}[chunkId] + ".chunk.js";
};